import { Add } from "@mui/icons-material";
import {
    Avatar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    IconButton,
    Input,
    InputLabel,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PlaceholderImage from "../../../app/assets/images/promotionPlaceholderImage.png";
import MkAutoComplete from "../../../app/assets/theme/MkAutoComplete";
import AlertBox from "../../../app/components/AlertBox/AlertBox";
import InputFormComponent from "../../../app/components/Form/InputFormComponent";
import generateColor from "../../../app/helper/generateColor";
import { addPromotion } from "../../../features/company/CampaignApi";

const providorTypeOptions = [
    { label: "---- SELECT TYPE ----", value: null },
    { label: "REWARD_POINT", value: "REWARD_POINT" },
    { label: "TOKEN", value: "TOKEN" },
];

export default function PromotionAdd() {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const user = useSelector((state) => state).loginInfo;
    const { campaignInfo } = useSelector((state) => state.campaignDetail);

    const { promotionList } = useSelector((state) => state.promotions);
    const [alertState, setAlertState] = useState();
    //for validation
    const [percent, setPercent] = useState(0);
    const [amount, setAmount] = useState(0);
    const [disablePercent, setDisablePercent] = useState(
        amount === 0 ? false : true
    );
    const [disableAmount, setDisableAmount] = useState(
        percent === 0 ? false : true
    );
    const [imageData, setImageData] = useState("#");
    const [providorType, setProvidorType] = useState(providorTypeOptions[0]);
    const [points, setPoints] = useState(0);
    const [tokens, setTokens] = useState(0);
    const [promotionId, setPromotionId] = useState("");
    const providorValue = providorType?.value;
    const isDefaultProvidor = providorValue === null || providorValue === undefined;
    const isRewardPoint = providorValue === "REWARD_POINT";
    const isToken = providorValue === "TOKEN";

    useEffect(() => {
        setDisablePercent(amount === 0 ? false : true);
        setDisableAmount(percent === 0 ? false : true);
    }, [percent, amount]);

    const handleClose = () => {
        setOpen(false);
        setAmount(0);
        setPercent(0);
        setImageData("#");
        setProvidorType(providorTypeOptions[0]);
        setPoints(0);
        setTokens(0);
        setPromotionId("");
    };

    const handleClickOpen = () => {
        setImageData(PlaceholderImage);
        setOpen(true);
    };

    const imageInputChange = (e) => {
        const [file] = e.target.files;
        if (file) {
            // setImageChange(true);
            setImageData(URL.createObjectURL(file));
        }
    };

    const handleAdd = (event) => {
        event.preventDefault();
        const color = generateColor();
        const formData = new FormData(event.currentTarget);
        formData.append("admin_id", user.admin.id);
        formData.append("campaign_id", campaignInfo.id);
        formData.set("provider_type", providorValue ?? "");
        formData.set("providor_type", providorValue ?? "");

        if (isDefaultProvidor) {
            formData.set("amount", Number(amount) || 0);
            formData.set("percent", Number(percent) || 0);
            formData.set("promotion_id", promotionId || "");
            formData.set("points", 0);
            formData.set("tokens", 0);
        }
        if (isRewardPoint) {
            formData.set("amount", 0);
            formData.set("percent", 0);
            formData.set("promotion_id", "");
            formData.set("points", Number(points) || 0);
            formData.set("tokens", 0);
        }
        if (isToken) {
            formData.set("amount", 0);
            formData.set("percent", 0);
            formData.set("promotion_id", "");
            formData.set("points", 0);
            formData.set("tokens", Number(tokens) || 0);
        }
        console.log(color);
        formData.append("bg_color", `#${color}`);
        if (
            formData.get("title") === "" ||
            formData.get("description") === ""
        ) {
            setAlertState({
                open: true,
                vertical: "top",
                horizontal: "right",
                variant: "error",
                message: "Please fill Title and Description!",
            });
            return;
        }
        if (promotionList.length >= 15) {
            setAlertState({
                open: true,
                vertical: "top",
                horizontal: "right",
                variant: "error",
                message: "Promotion Limited at 15!",
            });
            return;
        }
        dispatch(addPromotion({ data: formData }));
        setOpen(false);
        setAmount(0);
        setPercent(0);
        setProvidorType(providorTypeOptions[0]);
        setPoints(0);
        setTokens(0);
        setPromotionId("");
    };

    return (
        <>
            <IconButton
                onClick={handleClickOpen}
                sx={{ display: campaignInfo.finish === 1 ? "none" : "" }}
            >
                <Add sx={{ color: "#2152ff" }} />
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                component="form"
                onSubmit={handleAdd}
            >
                <DialogContent>
                    <Box sx={{ padding: "25px 10px" }}>
                        <Box>
                            <Typography variant="h4" mb={3}>
                                Add New Promotion
                            </Typography>
                            <Grid
                                container
                                rowSpacing={1}
                                columnSpacing={{
                                    xs: 1,
                                    sm: 2,
                                    md: 22,
                                }}
                            >
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <label htmlFor="contained-button-file">
                                            <Input
                                                accept="image/*"
                                                id="contained-button-file"
                                                type="file"
                                                name="image"
                                                sx={{
                                                    display: "none",
                                                }}
                                                onChange={imageInputChange}
                                            />
                                            <Avatar
                                                sx={{
                                                    width: "100%",
                                                    height: "200px",
                                                    cursor: "pointer",
                                                }}
                                                variant="rounded"
                                                src={imageData}
                                            />
                                        </label>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}></Grid>
                                <Grid item xs={12} md={6}>
                                    <InputFormComponent
                                        lable="Title"
                                        name="title"
                                        placeholder="Enter Promotion Title"
                                        focus={true}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <InputFormComponent
                                        lable="description"
                                        name="description"
                                        placeholder="Enter Description"
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <InputFormComponent
                                        inputProps={{ min: 0 }}
                                        type="number"
                                        defaultValue={0}
                                        lable="Expected Maximum"
                                        name="expected_maximum"
                                        placeholder="Enter Expected Maximum"
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="providor-type"
                                        sx={{ mb: 1, fontSize: "14.5px" }}
                                    >
                                        Providor Type
                                    </InputLabel>
                                    <MkAutoComplete
                                        id="providor-type"
                                        fullWidth={true}
                                        disableClearable
                                        options={providorTypeOptions}
                                        placeholder="Select Providor Type"
                                        getOptionLabel={(option) =>
                                            option?.label ?? ""
                                        }
                                        isOptionEqualToValue={(
                                            option,
                                            value
                                        ) => option.value === value?.value}
                                        onChange={(e, newValue) =>
                                            setProvidorType(newValue)
                                        }
                                        value={providorType}
                                    />
                                </Grid>
                                {isDefaultProvidor && (
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <InputFormComponent
                                                inputProps={{ min: 0 }}
                                                defaultValue={0}
                                                type="number"
                                                onChange={(e) => {
                                                    setPercent(
                                                        Number(e.target.value)
                                                    );
                                                }}
                                                lable="Percent"
                                                name="percent"
                                                placeholder="Enter Percent"
                                                readOnly={disablePercent}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <InputFormComponent
                                                inputProps={{ min: 0 }}
                                                defaultValue={0}
                                                type="number"
                                                onChange={(e) => {
                                                    setAmount(
                                                        Number(
                                                            e.currentTarget
                                                                .value
                                                        )
                                                    );
                                                }}
                                                lable="Amount"
                                                name="amount"
                                                placeholder="Enter Amount"
                                                readOnly={disableAmount}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <InputFormComponent
                                                value={promotionId}
                                                onChange={(e) =>
                                                    setPromotionId(
                                                        e.currentTarget.value
                                                    )
                                                }
                                                lable="Promotion ID"
                                                name="promotion_id"
                                                placeholder="Enter Promotion ID"
                                            />
                                        </Grid>
                                    </>
                                )}
                                {isRewardPoint && (
                                    <Grid item xs={12} md={6}>
                                        <InputFormComponent
                                            inputProps={{ min: 0 }}
                                            type="number"
                                            value={points.toString()}
                                            onChange={(e) =>
                                                setPoints(
                                                    Number(e.target.value)
                                                )
                                            }
                                            lable="Points"
                                            name="points"
                                            placeholder="Enter Points"
                                        />
                                    </Grid>
                                )}
                                {isToken && (
                                    <Grid item xs={12} md={6}>
                                        <InputFormComponent
                                            inputProps={{ min: 0 }}
                                            type="number"
                                            value={tokens.toString()}
                                            onChange={(e) =>
                                                setTokens(
                                                    Number(e.target.value)
                                                )
                                            }
                                            lable="Tokens"
                                            name="tokens"
                                            placeholder="Enter Tokens"
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ padding: "15px 35px" }}>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="submit">Add</Button>
                </DialogActions>
            </Dialog>
            <AlertBox alertState={alertState} />
        </>
    );
}
